/* Personalise section for the street name print family (street name, water works, property card, game boards, multi street), styled like the map prints. Where the print has to be personalised (no tick box) the section sits under one button and is OPEN; where it is optional (the "Personalise your print?" tick box) a card is the on/off switch and the fields appear under it once it is on. Everything drives the real form fields, so the order data and price work as before. */
(function () {
  /* the theme only loads this script on the products it is meant for */
  if (!/\/products\//.test(location.pathname)) return;
  var PEN = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 20h9"/><path d="M16.5 3.5a2.1 2.1 0 0 1 3 3L7 19l-4 1 1-4Z"/></svg>';
  var CHEV = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m6 9 6 6 6-6"/></svg>';
  var open = true, cssDone = false, errSeen = false;
  /* prints that only make sense personalised: the tick box is switched on for the customer and the card has no Remove button */
  var REQ = /\/products\/(custom-definition-print|personalised-quote-print-typewriter-font|custom-quote-or-song-lyric-print)/.test(location.pathname), tickTries = 0;
  var zst = document.createElement('style');
  zst.textContent = 'body:not(.fpg-single) .fp-zsheet .fp-zpers{display:none!important}';
  document.head.appendChild(zst);

  function css() {
    if (cssDone) return;
    cssDone = true;
    var s = document.createElement('style');
    s.id = 'fpg-css';
    s.textContent =
      '.fpg-h,.fpg-dup,.fpg-hide{display:none!important}' +
      'body:not(#fpz) product-info button[name="add"] .btn-text>span{white-space:nowrap}' +
      '#fpg-row,#fpg-card{box-sizing:border-box;width:100%;display:flex;align-items:center;gap:12px;margin:14px 0 0;padding:12px 14px;border:1.5px solid #ff0a89;border-radius:14px;background:#fff5fa;color:#111;font-family:inherit;text-align:left;scroll-margin-top:90px;transition:border-color .15s,background .15s}' +
      '#fpg-row{cursor:pointer}' +
      '#fpg-row[aria-expanded=true]{background:#fff;margin-bottom:10px}' +
      '#fpg-card{border-color:#d3d6dc;background:#fff;margin:14px 0 10px}' +
      '#fpg-card.on{border-color:#ff0a89;background:#fff5fa}' +
      '.fpg-i{flex:none;width:36px;height:36px;border-radius:50%;background:#ffe6f2;color:#ff0a89;display:flex;align-items:center;justify-content:center}' +
      '.fpg-t{flex:1;min-width:0}' +
      '.fpg-t b{display:block;font-size:15px;line-height:1.25;font-weight:700;color:#111}' +
      '.fpg-t span{display:block;font-size:13px;line-height:1.3;color:#555;margin-top:1px}' +
      '.fpg-t span.fpg-e{color:#ff0a89;font-weight:600;font-size:12px;margin-top:2px}' +
      '.fpg-t span.fpg-e:empty{display:none}' +
      '.fpg-n{flex:none;border-radius:999px;background:#ff0a89;color:#fff;font-size:12px;font-weight:600;line-height:1;padding:5px 9px}' +
      '.fpg-n[hidden]{display:none}' +
      '.fpg-c{flex:none;display:flex;color:#ff0a89;transition:transform .2s}' +
      '#fpg-row[aria-expanded=true] .fpg-c{transform:rotate(180deg)}' +
      '.fpg-b{flex:none;border:0;border-radius:999px;background:#ff0a89;color:#fff;font-family:inherit;font-size:14px;font-weight:600;line-height:1;padding:12px 16px;cursor:pointer}' +
      '#fpg-card.on .fpg-b{background:#fff;color:#ff0a89;box-shadow:0 0 0 1.5px #ff0a89 inset}' +
      '#fpg-card.lock .fpg-b{display:none}' +
      'body:not(#fpz) .gpo-group__childs:has(.fpg-f),body:not(#fpz) .gpo-group__childs:has(#fpg-row),body:not(#fpz) .gpo-group__childs:has(#fpg-card){margin-left:0!important;margin-right:0!important}' +
      '.fpg-f .dropdown-button{box-sizing:border-box!important;min-height:50px;padding:13px 14px!important;border:1.5px solid #9aa1ac!important;border-radius:12px!important;background:#fff!important;font-family:inherit!important;font-size:16px!important;color:#111;box-shadow:none!important}' +
      'body:not(#fpz) .gpo-element.gpo-form__group.fpg-f .gpo-dropdown .dropdown-button{border:1.5px solid #9aa1ac!important;box-shadow:none!important}' +
      'body:not(#fpz) .gpo-element.gpo-form__group.fpg-f .gpo-dropdown.open .dropdown-button{border-color:#ff0a89!important}' +
      '.fpg-f .dropdown-button__value{font-family:inherit!important;font-size:16px!important}' +
      '.fpg-f .gpo-dropdown.open .dropdown-button,.fpg-f .dropdown-button:focus{border-color:#ff0a89!important}' +
      /* plain (native) drop-down lists, e.g. Number Of Locations: same rounded grey box as the text fields, pink arrow, pink border when open */
      'body:not(#fpz) .gpo-element.gpo-form__group.fpg-f select{-webkit-appearance:none!important;-moz-appearance:none!important;appearance:none!important;box-sizing:border-box!important;display:block;width:100%!important;min-height:50px;padding:13px 44px 13px 14px!important;border:1.5px solid #9aa1ac!important;border-radius:12px!important;background:#fff url(data:image/svg+xml,%3Csvg%20xmlns%3D%27http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%27%20width%3D%2718%27%20height%3D%2718%27%20viewBox%3D%270%200%2024%2024%27%20fill%3D%27none%27%20stroke%3D%27%23ff0a89%27%20stroke-width%3D%272.4%27%20stroke-linecap%3D%27round%27%20stroke-linejoin%3D%27round%27%3E%3Cpath%20d%3D%27m6%209%206%206%206-6%27%2F%3E%3C%2Fsvg%3E) no-repeat right 14px center!important;background-size:18px 18px!important;color:#111!important;font-family:inherit!important;font-size:16px!important;line-height:1.3!important;font-weight:400!important;box-shadow:none!important;outline:0!important;text-overflow:ellipsis}' +
      'body:not(#fpz) .gpo-element.gpo-form__group.fpg-f select:focus{border-color:#ff0a89!important;box-shadow:inset 0 0 0 1px #ff0a89!important}' +
      'body:not(#fpz) .gpo-element.gpo-form__group.fpg-f.has-error select{border-color:#d92d20!important}' +
      'body:not(#fpz) product-info gpo-container{margin-top:2px!important;margin-bottom:0!important}' +
      'body:not(#fpz) .gpo-element.gpo-form__group.fpg-f{margin:0 0 8px!important;padding:0!important;outline:0!important;box-shadow:none!important}' +
      'body:not(#fpz) .gpo-element.gpo-form__group.fpg-f:has(.gpo-heading h5){margin-bottom:5px!important}' +
      'body:not(#fpz) .gpo-element.gpo-form__group.fpg-f.fpg-intro{margin-bottom:10px!important}' +
      'body:not(#fpz) .gpo-element.gpo-form__group.fpg-f:has(.gpo-heading h6){margin:-3px 0 8px!important}' +
      '.fpg-f .gpo-heading{margin:0!important;padding:0!important}' +
      '.fpg-f .gpo-heading h5{margin:0!important;font-family:inherit!important;font-size:13px!important;line-height:1.35!important;font-weight:600!important;color:#111!important}' +
      '.fpg-f .gpo-heading h6{margin:0!important;font-family:inherit!important;font-size:12px!important;line-height:1.4!important;font-weight:400!important;font-style:normal!important;color:#666!important}' +
      '.fpg-f>.gpo-label,.fpg-f>.gpo-label *{font-family:inherit!important}' +
      '.fpg-f>.gpo-label{display:block!important;margin:0 0 5px!important;padding:0!important;font-size:13px!important;line-height:1.35!important;font-weight:600!important;color:#111!important}' +
      '.fpg-f>.gpo-label .label-content{font-size:13px!important;font-weight:600!important;color:#111!important}' +
      '.fpg-f .gpo-input-wrap{margin:0!important;padding:0!important;border:0!important;border-radius:0!important;background:none!important;box-shadow:none!important;outline:0!important}' +
      '.fpg-f .gpo-input{box-sizing:border-box;width:100%;padding:13px 14px!important;border:1.5px solid #9aa1ac!important;border-radius:12px!important;background:#fff!important;color:#111;font-family:inherit!important;font-size:16px!important;line-height:1.3!important;box-shadow:none!important;outline:0;transition:border-color .15s}' +
      'body:not(#fpz) .gpo-element.gpo-form__group.fpg-f .gpo-input-wrap input.gpo-input,body:not(#fpz) .gpo-element.gpo-form__group.fpg-f .gpo-input-wrap textarea.gpo-input{box-sizing:border-box!important;padding:13px 14px!important;border:1.5px solid #9aa1ac!important;border-radius:12px!important;outline:0!important}' +
      'body:not(#fpz) .gpo-element.gpo-form__group.fpg-f .gpo-input-wrap .gpo-input:focus{border-color:#ff0a89!important;box-shadow:inset 0 0 0 1px #ff0a89!important;outline:0!important}' +
      'body:not(#fpz) .gpo-element.gpo-form__group.fpg-f.has-error .gpo-input-wrap input.gpo-input,body:not(#fpz) .gpo-element.gpo-form__group.fpg-f.has-error .gpo-input-wrap textarea.gpo-input{border-color:#d92d20!important}' +
      '.fpg-f .help-block.error{margin:4px 0 0!important;padding:0!important;font-size:12px!important;line-height:1.3!important;font-weight:600!important;color:#d92d20!important}' +
      '.fpg-f .gpo-input::placeholder{color:#8a8f98}' +
      '.fpg-f .gpo-textarea{min-height:84px;resize:vertical}' +
      '.fpg-f .gpo-color-box{position:relative}' +
      'body:not(#fpz) .gpo-element.gpo-form__group.fpg-f .gpo-color-box .preview-btn{left:9px!important;top:50%!important;transform:translateY(-50%)!important;width:32px!important;height:32px!important;border-radius:8px!important;border:1.5px solid #9aa1ac!important;box-sizing:border-box!important}' +
      'body:not(#fpz) .gpo-element.gpo-form__group.fpg-f .gpo-color-box input.gpo-input{padding-left:66px!important}' +
      '.fpg-f .gpo-choicelist{position:relative;margin:0!important;padding:0!important}' +
      '.fpg-f .gpo-choicelist input[type=checkbox]{position:absolute!important;opacity:0!important;width:1px!important;height:1px!important;pointer-events:none}' +
      '.fpg-f .gpo-choicelist.gpo-checkbox>label{box-sizing:border-box;display:flex!important;align-items:center;flex-wrap:wrap;gap:2px 8px;width:100%;margin:0!important;padding:12px 14px!important;border:1.5px solid #9aa1ac;border-radius:12px;background:#fff;color:#111;font-family:inherit!important;font-size:15px;line-height:1.25;font-weight:600;cursor:pointer;transition:border-color .15s,background .15s}' +
      '.fpg-f .gpo-choicelist.gpo-checkbox>label *{font-family:inherit!important;font-size:15px!important;font-weight:600!important;line-height:1.25!important}' +
      '.fpg-f .gpo-choicelist.gpo-checkbox>label::before,.fpg-f .gpo-choicelist.gpo-checkbox>label::after{display:none!important}' +
      '.fpg-f .gpo-choicelist.gpo-checkbox>input:checked+label{border-color:#ff0a89;background:#fff5fa;color:#ff0a89;box-shadow:inset 0 0 0 1px #ff0a89}' +
      '.fpg-f .gpo-choicelist.gpo-checkbox>input:checked+label::after{display:block!important;content:"\\2713";margin-left:auto;font-weight:700}' +
      '.fpg-f .gpo-ov-wrapper{margin:0!important;padding:0!important}' +
      '.fpg-f .messages{margin:0!important;padding:0!important}';
    document.head.appendChild(s);
  }

  function norm(t) { return String(t || '').replace(/\s+/g, ' ').trim().toLowerCase(); }
  function leaf(e) { return !e.querySelector('.gpo-element'); }
  function label0(e) { var l = e.querySelector('.label-content'); return l ? l.textContent.trim() : ''; }
  function skip(e) {
    return /^(Print Finish|Mount|Print Border Options)/i.test(label0(e)) || !!e.querySelector('input[name="Print Border Options"],select[name^="Print Finish"]') || e.classList.contains('fpg-hide');
  }
  function cbx() {
    var l = document.querySelectorAll('input[type="checkbox"]'), i;
    for (i = 0; i < l.length; i++) if (/^personalis/i.test(l[i].getAttribute('data-field-name') || '')) return l[i];
    return null;
  }
  function labelFor(c) { return (c.id && document.querySelector('label[for="' + c.id + '"]')) || c.closest('label'); }

  /* every plain form block after (and including) `from`, in page order, minus the finish, mount and border blocks */
  function listFrom(from, root) {
    var all = root.querySelectorAll('.gpo-element'), out = [], i, e;
    for (i = 0; i < all.length; i++) {
      e = all[i];
      if (!leaf(e) || skip(e)) continue;
      if (e === from || (from.compareDocumentPosition(e) & 4)) out.push(e);
    }
    return out;
  }
  function headStart(root) {
    var all = root.querySelectorAll('.gpo-element'), i, e;
    for (i = 0; i < all.length; i++) {
      e = all[i];
      if (leaf(e) && !e.querySelector('input,textarea,select') && /^(personalise your print\s*(\(|$)|leave blank any fields not required)/i.test(e.textContent.trim().replace(/\s+/g, ' '))) return e;
    }
    /* no heading on the page: the section starts at the first text, upload or email box */
    for (i = 0; i < all.length; i++) {
      e = all[i];
      if (leaf(e) && !skip(e) && e.querySelector('input[type="text"]:not(.gpo-color),textarea,input[type="file"],input[type="email"]')) return e;
    }
    return null;
  }

  function summary(list) {
    var cnt = 0, ex = [], i, j, cb, ta, lab, nm, ins;
    for (i = 0; i < list.length; i++) {
      cb = list[i].querySelectorAll('input[type="checkbox"]');
      for (j = 0; j < cb.length; j++) {
        if (!cb[j].checked) continue;
        cnt++;
        lab = labelFor(cb[j]);
        nm = lab ? lab.textContent.replace(/\s+/g, ' ').replace(/\s*\(order by[^)]*\)/i, '').trim() : '';
        if (nm) ex.push(nm);
      }
      ins = list[i].querySelectorAll('input[type="text"]:not(.gpo-color)');
      for (j = 0; j < ins.length; j++) if (ins[j].value.trim()) cnt++;
      ta = list[i].querySelectorAll('textarea');
      for (j = 0; j < ta.length; j++) if (ta[j].value.trim()) { cnt++; ex.push('Notes added'); }
    }
    return { cnt: cnt, ex: ex };
  }
  /* one text line only (a single map print): the zoom sheet keeps its Personalise box; with more lines it is hidden */
  function oneLine(list) {
    var n = 0, i;
    for (i = 0; i < list.length; i++) n += list[i].querySelectorAll('input[type="text"]:not(.gpo-color),textarea:not([name="Your Notes"])').length;
    document.body.classList.toggle('fpg-single', n === 1);
  }
  function dedupe(list) {
    var hs = [], i, j, ta, v, h6, hk;
    for (i = 0; i < list.length; i++) {
      ta = list[i].querySelectorAll('.gpo-ov-helptext');
      for (j = 0; j < ta.length; j++) { v = norm(ta[j].textContent).slice(0, 40); if (v.length >= 20) hs.push(v); }
    }
    for (i = 0; i < list.length; i++) {
      h6 = list[i].querySelector('.gpo-heading h6');
      hk = h6 ? norm(h6.textContent).slice(0, 40) : '';
      list[i].classList.toggle('fpg-dup', !!(h6 && hk.length >= 20 && !list[i].querySelector('input,textarea,select') && hs.indexOf(hk) > -1));
    }
  }

  function sync() {
    var root = document.querySelector('product-info');
    if (!root) return;
    var c = cbx(), list, from, card, row, i, s;
    /* the map listings with their own Make it yours card are looked after by the other script */
    if (document.body.classList.contains('fpx-opt')) return;
    css();
    if (c) {
      /* optional personalising: a card is the on/off switch for the real tick box */
      from = c.closest('.gpo-element');
      if (!from) return;
      from.classList.add('fpg-hide');
      var hd = root.querySelectorAll('.gpo-element'), hi;
      for (hi = 0; hi < hd.length; hi++) if (leaf(hd[hi]) && !hd[hi].querySelector('input,textarea,select') && /^personalise your print\??$/i.test(hd[hi].textContent.trim().replace(/\s+/g, ' '))) hd[hi].classList.add('fpg-hide');
      row = document.getElementById('fpg-row'); row && row.parentNode.removeChild(row);
      list = listFrom(from, root).filter(function (e) { return e !== from; });
      card = document.getElementById('fpg-card');
      if (!card) {
        card = document.createElement('div');
        card.id = 'fpg-card';
        card.innerHTML = '<span class="fpg-i">' + PEN + '</span><div class="fpg-t"><b></b><span class="fpg-s"></span><span class="fpg-e"></span></div><button type="button" class="fpg-b"></button>';
        card.querySelector('button').addEventListener('click', function () {
          var cc = cbx(), l = cc && labelFor(cc);
          if (!cc) return;
          (l || cc).click();
          setTimeout(sync, 60);
        });
      }
      if (card.nextElementSibling !== from && from.previousElementSibling !== card) from.parentNode.insertBefore(card, from);
      s = summary(list);
      if (REQ && !c.checked && tickTries < 4) { tickTries++; (labelFor(c) || c).click(); }
      var on = !!c.checked;
      card.classList.toggle('on', on);
      card.classList.toggle('lock', REQ);
      var t = card.querySelector('b'), d = card.querySelector('.fpg-s'), x = card.querySelector('.fpg-e'), b = card.querySelector('button');
      var tt = on ? 'Personalise your print' : 'Make it yours', dt = on ? 'Fill in the boxes below' : 'Add your own colour, notes or extras', xt = on ? s.ex.join(' · ') : '', bt = on ? 'Remove' : 'Personalise';
      if (t.textContent !== tt) t.textContent = tt;
      if (d.textContent !== dt) d.textContent = dt;
      if (x.textContent !== xt) x.textContent = xt;
      if (b.textContent !== bt) b.textContent = bt;
      oneLine(list);
      dedupe(list);
      for (i = 0; i < list.length; i++) { list[i].classList.add('fpg-f'); list[i].classList.remove('fpg-h'); list[i].classList.toggle('fpg-intro', i === 0); }
      return;
    }
    /* personalising is part of the print: one box under a button, open when the page loads */
    from = headStart(root);
    card = document.getElementById('fpg-card'); card && card.parentNode.removeChild(card);
    row = document.getElementById('fpg-row');
    if (!from) { row && row.parentNode.removeChild(row); return; }
    list = listFrom(from, root);
    oneLine(list);
    dedupe(list);
    /* a lone "Personalise your print" heading just repeats the button's title */
    if (/^personalise your print$/i.test(from.textContent.trim().replace(/\s+/g, ' '))) from.classList.add('fpg-dup');
    if (!row) {
      row = document.createElement('button');
      row.type = 'button';
      row.id = 'fpg-row';
      row.innerHTML = '<span class="fpg-i">' + PEN + '</span><span class="fpg-t"><b></b><span class="fpg-s"></span><span class="fpg-e"></span></span><span class="fpg-n" hidden></span><span class="fpg-c">' + CHEV + '</span>';
      row.addEventListener('click', function () { open = !open; sync(); });
    }
    if (row.nextElementSibling !== from) from.parentNode.insertBefore(row, from);
    var bad = false;
    for (i = 0; i < list.length; i++) if (list[i].classList.contains('has-error')) { bad = true; break; }
    if (!bad) errSeen = false; else if (!errSeen) { errSeen = true; open = true; }
    s = summary(list);
    var ttl = row.querySelector('.fpg-t b'), sub = row.querySelector('.fpg-s'), ex = row.querySelector('.fpg-e'), badge = row.querySelector('.fpg-n');
    var t2 = open ? 'Personalise your print' : (s.cnt ? 'Your personalisation' : 'Click here to personalise');
    var s2 = open ? 'Tap here to close once you’ve finished' : 'Your text, colours & extras';
    var e2 = open ? '' : s.ex.join(' · '), b2 = (s.cnt && !open) ? s.cnt + ' added' : '';
    if (ttl.textContent !== t2) ttl.textContent = t2;
    if (sub.textContent !== s2) sub.textContent = s2;
    if (ex.textContent !== e2) ex.textContent = e2;
    if (badge.textContent !== b2) badge.textContent = b2;
    badge.hidden = !b2;
    row.setAttribute('aria-expanded', open ? 'true' : 'false');
    for (i = 0; i < list.length; i++) {
      list[i].classList.add('fpg-f');
      list[i].classList.toggle('fpg-intro', i === 0);
      list[i].classList.toggle('fpg-h', !open);
    }
  }

  /* The price on the page, in whatever format the market uses (£44.50, $54.95, €54,95, CHF 54.95, 54,95 €, €1.234,56), times the quantity, written back in that same format. Returns null when no price can be read. */
  function money(text, qty) {
    var s = String(text || '').replace(/\s+/g, ' ').trim();
    var m = /\d[\d.,' ]*\d|\d/.exec(s);
    if (!m) return null;
    var tok = m[0].replace(/[ ']/g, '');
    var dm = /^(.*?)([.,])(\d{1,2})$/.exec(tok);
    var whole = (dm ? dm[1] : tok).replace(/[.,]/g, '');
    if (!/^\d+$/.test(whole)) return null;
    var val = parseFloat(whole + (dm ? '.' + dm[3] : ''));
    if (!isFinite(val)) return null;
    val = val * (qty > 0 ? qty : 1);
    var dec = dm ? dm[2] : null, thou = dec === ',' ? '.' : ',';
    var grouped = dm ? /[.,]/.test(dm[1]) : /[.,]/.test(tok);
    var parts = (dec ? val.toFixed(2) : String(Math.round(val))).split('.'), out = parts[0];
    if (grouped || out.length > 3) out = out.replace(/\B(?=(\d{3})+(?!\d))/g, thou);
    if (dec) out += dec + parts[1];
    /* a currency symbol or code before or after the number: a symbol, a 3 letter code such as CHF, or a short name such as kr */
    function cur(t) { return !!t && (/[^A-Za-z]/.test(t) || /^[A-Z]{3}$/.test(t) || /^(kr|zł|Kč|ft|lei|rs)$/i.test(t)); }
    var before = s.slice(0, m.index), after = s.slice(m.index + m[0].length);
    var lead = /([^\s\d.,]{1,4})(\s*)$/.exec(before), trail = /^(\s*)([^\s\d.,]{1,4})(?=\s|$)/.exec(after);
    lead = lead && cur(lead[1]) ? lead : null;
    trail = trail && cur(trail[2]) ? trail : null;
    /* "€54,95 EUR": the symbol leads, so the trailing code is just the page repeating itself */
    if (lead && trail && /^[A-Z]{3}$/.test(trail[2])) trail = null;
    return (lead ? lead[1] + (lead[2] ? ' ' : '') : '') + out + (trail ? (trail[1] ? ' ' : '') + trail[2] : '');
  }

  /* the Add to cart button shows the live total, e.g. "Add to cart · £94.00": the price on the page already includes the finish and extras, so this is that price times the quantity. Only the words change. If the price cannot be read the button just says "Add to cart" rather than show a wrong total. */
  function syncPrice() {
    var sec = document.querySelector('product-info');
    if (!sec) return;
    var b = sec.querySelector('button[name="add"]'), sp = b && b.querySelector('.btn-text > span');
    if (!sp) return;
    var cur = sp.textContent.trim();
    if (!/^add to cart/i.test(cur)) return;
    var pe = sec.querySelector('.product__price .price__regular') || sec.querySelector('.product__price');
    var qi = sec.querySelector('input[name="quantity"]'), qn = Math.max(1, parseInt(qi && qi.value, 10) || 1);
    var p = pe ? money(pe.textContent, qn) : null;
    var t = p ? 'Add to cart · ' + p : 'Add to cart';
    if (cur !== t) sp.textContent = t;
  }

  /* Add to cart pressed with a required field empty: the form app refuses and flags the field, but the flag can sit out of sight. For a few seconds the page is eased onto the first flagged field (the box opens if it was closed) and the cursor goes in it. A missing finish (flagged by the other script, higher up the page) goes first. Lets go as soon as the customer scrolls, touches or types. */
  var guardId = 0, lastAdd = 0;
  function firstBad() {
    var l = document.querySelectorAll('.fpg-f.has-error'), i;
    for (i = 0; i < l.length; i++) if (l[i].offsetParent !== null) return l[i];
    return null;
  }
  function startGuard() {
    var id = ++guardId, t0 = Date.now(), lockedAt = 0, focused = false;
    var evs = ['wheel', 'touchstart', 'mousedown', 'keydown'];
    function stop() {
      guardId++;
      evs.forEach(function (n) { window.removeEventListener(n, stop, true); });
    }
    setTimeout(function () {
      if (id === guardId) evs.forEach(function (n) { window.addEventListener(n, stop, true); });
    }, 250);
    function frame() {
      if (id !== guardId) return;
      var now = Date.now();
      if (now - t0 > 6000) { stop(); return; }
      var e = firstBad();
      if (e && !document.querySelector('.fp-ferr, .fp-sterr')) {
        if (!lockedAt) lockedAt = now;
        if (now - lockedAt > 2500) { stop(); return; }
        var y = Math.max(0, e.getBoundingClientRect().top + window.pageYOffset - 110), d = y - window.pageYOffset;
        if (Math.abs(d) > 2) {
          window.scrollTo({ top: Math.abs(d) < 12 ? y : window.pageYOffset + d * 0.2, behavior: 'instant' });
        } else if (!focused) {
          focused = true;
          var f = e.querySelector('input[type="text"]:not(.gpo-color),input[type="email"],textarea');
          f && f.focus({ preventScroll: true });
        }
      }
      requestAnimationFrame(frame);
    }
    requestAnimationFrame(frame);
  }
  function isAdd(t) {
    var b = t && t.closest && t.closest('button,input[type="submit"],[type="submit"]');
    if (!b) return false;
    return b.name === 'add' || b.classList.contains('product-form__submit') || /add to cart/i.test(b.textContent || b.value || '');
  }
  ['pointerup', 'click', 'touchend', 'keydown'].forEach(function (t) {
    window.addEventListener(t, function (e) {
      if (t === 'keydown' && e.key !== 'Enter' && e.key !== ' ') return;
      if (!isAdd(e.target)) return;
      var n = Date.now();
      if (n - lastAdd < 400) return;
      lastAdd = n;
      startGuard();
    }, true);
  });


  /* Enlarged view: the on-page art is the 1400px copy; once the zoom is open the full-size original is loaded and swapped in, so the zoom is as sharp as the file allows. */
  function hires() {
    if (!document.querySelector('.fp-zoom')) return;
    var x = window.__fpx, t = x && typeof x.art === 'function' && x.art();
    if (!t || !t.url || t.crop || t.__hq || !/^https?:|^\/\//.test(t.url)) return;
    var u = t.url.replace(/([?&])width=\d+&?/, '$1').replace(/[?&]$/, '');
    t.__hq = 1;
    if (u === t.url) return;
    var im = new Image();
    im.onload = function () {
      if (t.__o) t.__o = im; else t.img = im;
      var pi = document.querySelector('product-info');
      if (pi) pi.dispatchEvent(new Event('change', { bubbles: true }));
      try { if (window.__fpzoom && window.__fpzoom.redraw) window.__fpzoom.redraw(); } catch (e) { /* ignore */ }
    };
    im.src = u;
  }

  document.addEventListener('change', function () { setTimeout(sync, 80); }, true);
  document.addEventListener('input', function () { setTimeout(sync, 80); }, true);
  document.addEventListener('gpoRenderCompleted', function () { setTimeout(sync, 60); });
  setInterval(function () { try { sync(); syncPrice(); hires(); } catch (err) { /* ignore */ } }, 300);
})();
